import { Col, Form, Row, Table, Checkbox, ConfigProvider } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DeleteOutlined, PlusCircleOutlined } from "@ant-design/icons";
import SecondaryButton from "../../../../biblio/Buttons/SecondaryButton";
import Inputs from "../../../../biblio/Inputs/Inputs";
import { AppDispatch, RootState } from "../../../../apis/store";
import { showNotitfication } from "../../../../components/utils/utils";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import Selects from "../../../../biblio/Selects/Selects";
import ModalComponent from "../../../../biblio/Modal/ModalComponent";
import { getSponsoredOrphans } from "../../../../apis/actions/sponsor.actions";
import { useTranslation } from "react-i18next";
import {
  cancelSponsorship,
  getSponsorshipCancel,
} from "../../../../apis/actions/sponsorship.actions";
import { setResModel, setResIds } from "../../../../apis/slices/ratingSlice";
import InputDate from "../../../../biblio/Inputs/InputDate";
import { allowOnlyFirstDay } from "../orphans/utils";
import ar_EG from "antd/lib/locale/ar_EG";
import dayjs from "dayjs";

interface servicesRequestCardProps {
  isModalVisible?: boolean;
  cancelReasons: any;
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const CancelSponsorship = ({
  isModalVisible,
  setIsModalVisible,
  cancelReasons,
}: servicesRequestCardProps) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const [isTableVisible, setIsTableVisible] = useState(true);
  const [checkboxValue, setCheckboxValue] = useState(false);
  const [, setCancelStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const OtpId = useSelector((state: RootState) => state?.recipient?.OtpId);
  useEffect(() => {
    dispatch(getSponsoredOrphans({ sponsor_id: OtpId }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  const { sponsoredOrphans } = useSelector(
    (state: RootState) => state?.sponsor
  );

  const [list, setList] = useState<any[]>([
    {
      partner_id: "",
      current_sponsorship_status: "",
      cancel_sponsorship_status: "",
      sponsorship_cancel_date: "",
    },
  ]);
  const handleSwitch = (sponsorship: any) => {
    switch (sponsorship) {
      case "support":
        return "support";
      case "main":
        return "main";
      case "widow":
        return "widow";
      case "main_support":
        return "main_support";
      default:
        return "";
    }
  };
  const handleDateFieldChange = (field: string, e: any) => {
    form.setFieldsValue({ [field]: dayjs(e).format("YYYY-MM-DD") });
  };
  useEffect(() => {
    if (!isTableVisible) {
      setList([]);
    }
  }, [isTableVisible]);

  const handleDateChange = (date: any, index: number) => {
    const parsedDate = dayjs(date);
    if (parsedDate.isValid()) {
      const updatedList = [...list];
      updatedList[index].sponsorship_cancel_date =
        parsedDate.format("YYYY-MM-DD");
      setList(updatedList);
    }
  };
  const toAdd = () => {
    const availableBeneficiaries = sponsoredOrphans.filter(
      (orphan: any) => !list.some((item) => item.partner_id === orphan.id)
    );

    if (availableBeneficiaries.length > 0) {
      setList([
        ...list,
        {
          partner_id: "",
          current_sponsorship_status: "",
          cancel_sponsorship_status: "",
          sponsorship_cancel_date: "",
        },
      ]);
    }
  };

  const toDelete = (index: number) => {
  const updatedList = [...list];
  const deletedPartnerId = updatedList[index].partner_id;

  // Remove the selected row
  updatedList.splice(index, 1);

  // Re-evaluate if the deleted partner has only one row left
  const remainingLinesForPartner = updatedList.filter(
    (entry) => entry.partner_id === deletedPartnerId
  );

  if (remainingLinesForPartner.length === 1) {
    const idx = updatedList.findIndex(
      (entry) => entry.partner_id === deletedPartnerId
    );

    if (idx !== -1) {
      updatedList[idx] = {
        ...updatedList[idx],
        disable_cancel_type_select: false,
      };
    }
  }

  setList(updatedList);
};
const getAvailableBeneficiaries = (index: number) => {
  return sponsoredOrphans
    .filter((orphan: any) => {
      const existingSelections = list.filter((_, i) => i !== index);
      const entriesForThisOrphan = existingSelections.filter(
        (entry) => entry.partner_id === orphan.id
      );

      if (orphan.sponsorship_type === "main_support") {
        const selectedTypes = entriesForThisOrphan.map(
          (entry) => entry.cancel_sponsorship_status
        );
        const hasMain = selectedTypes.includes("main");
        const hasSupport = selectedTypes.includes("support");

        // Disallow adding if both already selected
        return !(hasMain && hasSupport);
      }

      return entriesForThisOrphan.length === 0;
    })
    .map((orphan: any) => ({
      id: orphan.id,
      name: `${orphan.firstname} ${orphan.father_name}`,
    }));
};

  const handleCheckboxChange = (e: any) => {
    setCheckboxValue(e.target.checked);
    setIsTableVisible(!e.target.checked);
  };

const onSelectChange = (e: any, index: number) => {
  const updatedList = [...list];
  const selectedOrphan = sponsoredOrphans.find((o: any) => o.id === e.value);

  if (!selectedOrphan) return;

  let cancelType = "";
  let disableSelection = false;

  const otherLines = updatedList.filter((_, i) => i !== index);
  const samePartnerLines = otherLines.filter(
    (entry) => entry.partner_id === selectedOrphan.id
  );
  const selectedTypes = samePartnerLines.map(
    (entry) => entry.cancel_sponsorship_status
  );

  if (selectedOrphan.sponsorship_type === "main_support") {
    if (selectedTypes.includes("main")) {
      cancelType = "support";
    } else if (selectedTypes.includes("support")) {
      cancelType = "main";
    } else {
      cancelType = "main";
    }

    // Temporarily store this line
    updatedList[index] = {
      partner_id: selectedOrphan.id,
      current_sponsorship_status: selectedOrphan.sponsorship_type,
      cancel_sponsorship_status: cancelType,
      sponsorship_cancel_date: updatedList[index]?.sponsorship_cancel_date || "",
      disable_cancel_type_select: false,
    };

    // Now count total lines for this partner after the update
    const linesForPartner = updatedList.filter(
      (entry) => entry.partner_id === selectedOrphan.id
    );

    // If both 'main' and 'support' exist → disable both
    const cancelTypes = linesForPartner.map((l) => l.cancel_sponsorship_status);
    if (cancelTypes.includes("main") && cancelTypes.includes("support")) {
      updatedList.forEach((line, idx) => {
        if (line.partner_id === selectedOrphan.id) {
          updatedList[idx] = {
            ...line,
            disable_cancel_type_select: true,
          };
        }
      });
    }
  } else {
    cancelType = handleSwitch(selectedOrphan.sponsorship_type);
    disableSelection = true;

    updatedList[index] = {
      partner_id: selectedOrphan.id,
      current_sponsorship_status: selectedOrphan.sponsorship_type,
      cancel_sponsorship_status: cancelType,
      sponsorship_cancel_date: updatedList[index]?.sponsorship_cancel_date || "",
      disable_cancel_type_select: disableSelection,
    };
  }

  setList(updatedList);
};


  const onSelectSponsorship = (e: any, index: number) => {
    const updatedList = [...list];
    updatedList[index].cancel_sponsorship_status = e.value;
    setList(updatedList);
  };
  const onFinish = async () => {
    try {
      await form.validateFields();
      setIsSubmitting(true);
      const cleanedList = list.map(
        ({ current_sponsorship_status, ...rest }) => ({
          ...rest,
          select_line: true,
        })
      );
      const FormValues = form.getFieldsValue();
      const sponsorshipFormData = {
        cancel_reason_id: FormValues.cancel_reason_id?.value,
        line_ids: cleanedList,
        all_sponsored: checkboxValue,
        sponsorship_cancel_date: FormValues.sponsorship_cancel_date,
        sponsor_id: OtpId,
      };

      dispatch(cancelSponsorship(sponsorshipFormData)).then((result: any) => {
        const sponsorship = result?.payload?.data?.result;
        if (sponsorship?.code === 200) {
          dispatch(setResModel(sponsorship?.res_model));
          dispatch(setResIds([sponsorship?.cancel_booking_request_id]));
          showNotitfication(`${sponsorship?.message}`, "success", dispatch);
          form.resetFields();
          setList([
            {
              partner_id: sponsoredOrphans[0]?.id,
              current_sponsorship_status:
                sponsoredOrphans[0]?.sponsorship_type,
              cancel_sponsorship_status: handleSwitch(
                sponsoredOrphans[0]?.sponsorship_type
              ),
            },
          ]);
          setIsModalVisible(false);
          dispatch(getSponsorshipCancel({ sponsor_id: OtpId }));
          resetModalState();
        } else {
          showNotitfication(sponsorship?.message, "error");
          setIsModalVisible(false);
          resetModalState();
        }
        setIsSubmitting(false);
      });
    } catch (error) {
      console.log(error);
      setIsSubmitting(false);
    }
  };
  const resetModalState = () => {
    form.resetFields();
    setList([
      {
        partner_id: "",
        current_sponsorship_status: "",
        cancel_sponsorship_status: "",
      },
    ]);
    setCheckboxValue(false);
    setIsTableVisible(true);
  };
  const handleModalClose = () => {
    resetModalState();
    setIsModalVisible(false);
  };
const mainSupportCount = (sponsoredOrphans || []).filter(
  (o: any) => o.sponsorship_type === "main_support"
).length;
  const columns = [
    {
      title: "المستفيد",
      dataIndex: "partner_id",
      width: 200,
      render: (value: any, record: any, index: number) => (
        <Selects
          value={value}
          style={{ width: "100%" }}
          popupMatchSelectWidth={220}
          allowClear={false}
          options={sponsoredOrphans ? getAvailableBeneficiaries(index) : []}
          className="takaful--request-select"
          onChange={(e) => onSelectChange(e, index)}
        />
      ),
    },
    {
      title: "نوع الكفالة الحالية",
      dataIndex: "current_sponsorship_status",
      width: 200,
      render: (value: any) => (
        <Inputs
          disabled
          className="takaful--donation-input"
          value={value ? t(`current_sponsorship_status.${value}`) : ""}
          style={{
            width: "100%",
            height: "40px",
            padding: "0 11px 0 0",
            fontSize: "1rem",
          }}
        />
      ),
    },

{
  title: "نوع الكفالة الملغاة",
  dataIndex: "cancel_sponsorship_status",
  width: 200,
  render: (value: any, record: any, index: number) => (
    <Selects
      disabled={
        record.current_sponsorship_status !== "main_support" ||
        record.disable_cancel_type_select
      }
      value={value ? t(`current_sponsorship_status.${value}`) : ""}
      style={{ width: "100%" }}
      popupMatchSelectWidth={220}
      options={
        record.current_sponsorship_status === "main_support"
          ? [
              { id: "main", name: "رئيسية" },
              { id: "support", name: "دعم" },
              // Removed: { id: "main_support", name: "كفالة رئيسة و دعم" }
            ]
          : []
      }
      className="takaful--request-select"
      onChange={(e: any) => {
        onSelectSponsorship(e, index);
        setCancelStatus(e.value);
      }}
      allowClear={false}
    />
  ),
},

    {
      title: " مدفوعة إلى",
      key: "sponsorship_paid_to",
      width: 150,
      render: (_: any, record: any) => {
        const orphan = sponsoredOrphans.find(
          (o: any) => o.id === record.partner_id
        );

        const getFormattedDate = (date: any) =>
          date ? dayjs(date).format("YYYY/MM/DD") : "";

        const value =
          record.cancel_sponsorship_status === "main"
            ? getFormattedDate(orphan?.main_sponsorship_paid_to) ||
              getFormattedDate(orphan?.sponsorship_paid_to)
            : record.cancel_sponsorship_status === "support"
            ? getFormattedDate(orphan?.support_sponsorship_paid_to) ||
              getFormattedDate(orphan?.sponsorship_paid_to)
            : getFormattedDate(orphan?.sponsorship_paid_to);

        return (
          <Inputs
            disabled
            className="takaful--donation-input"
            value={value}
            style={{
              width: "100%",
              height: "40px",
              padding: "0 11px 0 0",
              fontSize: "1rem",
            }}
          />
        );
      },
    },
    {
      title: "تاريخ إلغاء الكفالة",
      dataIndex: "sponsorship_cancel_date",
      width: 200,
      render: (value: any, record: any, index: number) => (
        <ConfigProvider locale={ar_EG} direction="rtl">
          <InputDate
            class="takaful--input-date-container-class"
            className="takaful--unsponsored-input-start-date"
            placeholder="اختر بداية الشهر"
            value={value ? dayjs(value) : null}
            disabledDate={allowOnlyFirstDay}
            onChange={(date) => handleDateChange(date, index)}
          />
        </ConfigProvider>
      ),
    },
    {
      title: (
        <PrimaryButton
          title={""}
          icon={<PlusCircleOutlined />}
          disabled={list.length === sponsoredOrphans?.length + mainSupportCount}
          onClick={() => toAdd()}
        />
      ),
      key: "actions",
      render: (text: any, record: any, index: number) =>
        list.length > 1 && (
          <PrimaryButton
            title={""}
            icon={<DeleteOutlined />}
            onClick={() => toDelete(index)}
          />
        ),
    },
  ];
  return (
    <ModalComponent
      title=""
      open={isModalVisible}
      onClose={handleModalClose}
      closeOnOutsideClick={true}
      width={950}
      centered={true}
      modalStyle={{ top: -200 }}
      destroyOnClose={true}
    >
      <div dir="rtl">
        <Form
          form={form}
          layout="horizontal"
          className="takaful--form-service-request"
        >
          <Row justify={"center"}>
            <p className="takaful--confirm-logout">إنشاء طلب إلغاء</p>
          </Row>
          <div style={{ marginTop: "2rem" }}>
            <Row gutter={16} align="middle">
              <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                <Form.Item
                  name="cancel_reason_id"
                  label="سبب الإلغاء"
                  rules={[
                    {
                      required: true,
                      message: "الرجاء تعبئة الحقل",
                    },
                  ]}
                  labelAlign="left"
                  labelCol={{
                    className: "takaful--label-style",
                    span: 6,
                  }}
                  wrapperCol={{
                    span: 18,
                  }}
                >
                  <Selects
                    options={cancelReasons}
                    selectPlaceholder="سبب الإلغاء"
                    allowClear={true}
                    className="takaful--request-select"
                    popupClassName="takaful--service-select-dropdown"
                  />
                </Form.Item>
              </Col>
              <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                <Form.Item
                  name="all_sponsored"
                  label="إلغاء كل كفالاتي"
                  labelAlign="left"
                  labelCol={{
                    className: "takaful--label-style",
                    xxl: 12,
                    xl: 12,
                    lg: 12,
                    md: 12,
                    sm: 12,
                    xs: 12,
                  }}
                  wrapperCol={{
                    xxl: 5,
                    xl: 5,
                    lg: 5,
                    md: 5,
                    sm: 10,
                    xs: 10,
                  }}
                >
                  <Checkbox onChange={handleCheckboxChange}></Checkbox>
                </Form.Item>
              </Col>
              {!isTableVisible && (
                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                  <Form.Item
                    name="sponsorship_cancel_date"
                    label="تاريخ إلغاء الكفالة"
                    labelAlign="left"
                    labelCol={{
                      className: "takaful--label-style",
                      span: 6,
                    }}
                    wrapperCol={{
                      span: 18,
                    }}
                    rules={[
                      {
                        required: true,
                        message: "الرجاء تعبئة الحقل",
                      },
                    ]}
                  >
                    <ConfigProvider locale={ar_EG} direction="rtl">
                      <InputDate
                        class="takaful--input-date-container-class"
                        className="takaful--unsponsored-input-start-date"
                        placeholder="اختر بداية الشهر"
                        disabledDate={allowOnlyFirstDay}
                        onChange={(e) =>
                          handleDateFieldChange("sponsorship_cancel_date", e)
                        }
                      />
                    </ConfigProvider>
                  </Form.Item>
                </Col>
              )}
            </Row>
          </div>
          {isTableVisible && (
            <Row>
              <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                <div className="takaful--table-container">
                  <Table
                    dataSource={list}
                    style={{ direction: "rtl" }}
                    scroll={{ x: "max-content" }}
                    columns={columns}
                    pagination={false}
                    className="takaful--table"
                    locale={{ emptyText: "لا يوجد بيانات" }}
                  />
                </div>
              </Col>
            </Row>
          )}
          <Row justify={"end"} dir="rtl">
            <Col xxl={5} xl={4} lg={4} md={4} sm={5} xs={7}>
              <SecondaryButton
                title="إلغاء"
                disabled={isSubmitting}
                loading={isSubmitting}
                className="takaful--services-request-button"
                onClick={() => onFinish()}
              />
            </Col>
          </Row>
        </Form>
      </div>
    </ModalComponent>
  );
};

export default CancelSponsorship;
